// ============================================================
//  src/components/LogoutModal.jsx
//  Confirmation dialog before logging out
// ============================================================

import config from "../config";

export default function LogoutModal({ user, onConfirm, onCancel }) {
  return (
    <div
      className="fade-in"
      onClick={onCancel}
      style={{
        position: "fixed", inset: 0,
        background: "rgba(0,0,0,0.55)",
        zIndex: 600,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
      }}
    >
      <div
        className="slide-up"
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff",
          borderRadius: 20,
          width: "100%",
          maxWidth: 360,
          overflow: "hidden",
          boxShadow: "0 20px 60px rgba(0,0,0,0.22)",
        }}
      >
        {/* Header */}
        <div style={{
          background: `linear-gradient(135deg, ${config.colors.primary}, ${config.colors.primaryLight})`,
          padding: "24px 24px 20px",
          color: "#fff",
          textAlign: "center",
        }}>
          <div style={{ fontSize: 44, marginBottom: 10 }}>👋</div>
          <div className="font-display" style={{ fontSize: 20, fontWeight: 800 }}>
            Logging out?
          </div>
          <div style={{ opacity: 0.85, fontSize: 13, marginTop: 4 }}>
            Signed in as <strong>{user?.name}</strong>
          </div>
        </div>

        {/* Body */}
        <div style={{ padding: "20px 22px 24px" }}>
          <div style={{
            background: "#faf8f5",
            borderRadius: 12,
            padding: "12px 14px",
            fontSize: 13,
            color: "#777",
            marginBottom: 20,
            lineHeight: 1.6,
            textAlign: "center",
          }}>
            Your cart will be saved. You can sign back in anytime to continue shopping.
          </div>

          {/* Confirm logout */}
          <button
            className="btn-press"
            onClick={onConfirm}
            style={{
              width: "100%",
              background: "#e74c3c",
              color: "#fff",
              border: "none",
              borderRadius: 13,
              padding: "14px 0",
              fontWeight: 800,
              fontSize: 15,
              cursor: "pointer",
              marginBottom: 10,
            }}
          >
            Yes, Log Out
          </button>

          {/* Cancel */}
          <button
            className="btn-press"
            onClick={onCancel}
            style={{
              width: "100%",
              background: "#fff",
              color: config.colors.primary,
              border: `2px solid ${config.colors.primary}`,
              borderRadius: 13,
              padding: "13px 0",
              fontWeight: 700,
              fontSize: 14,
              cursor: "pointer",
            }}
          >
            Stay Logged In
          </button>
        </div>
      </div>
    </div>
  );
}
